<template>
  <el-dropdown placemenet="bottom-end" @command="command">
    <span class="el-dropdown-link">
      <span> {{ value }} </span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <div class="dropdownForceScrollClass">
        <template v-for="option in optionsList">
          <el-dropdown-item :key="option" :command="option">
            {{ option }}
          </el-dropdown-item>
        </template>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  name: "base-dropdown",
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      default: () => []
    },
    optionsList: {
      type: Array,
      default: () => []
    },
    command: {
      type: Function,
      required: true
    }
  },
  methods: {}
};
</script>

<style>
.dropdownForceScrollClass {
  max-height: 265px;
  overflow: scroll;
  margin-top: 15px;
}

.el-dropdown-menu {
  padding: 0 0 0 0 !important;
  margin: 0 0 0 0 !important;
}
</style>
